export default {
    recovery: 'password_recovery',
    blocked: 'password_blocked',
    invalid: 'password_invalid',
    notFound: 'password_not_found',
    alreadyUsed: 'password_already_used',
    expired: 'password_expired'
};
